var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      directives: [{ name: "drag", rawName: "v-drag" }],
      attrs: {
        title: "权限分配",
        visible: _vm.dialogVisible,
        width: "840px",
        "show-close": true,
        "append-to-body": true,
        "close-on-click-modal": false,
        "close-on-press-escape": false,
        "before-close": _vm.cancel,
        top: "5%",
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
      },
    },
    [
      _c("span", { attrs: { slot: "title" }, slot: "title" }, [
        _c("img", {
          attrs: { src: require("@/assets/images/system/company.png") },
        }),
        _vm._v("成员调度 "),
      ]),
      _c("div", { staticClass: "content" }, [
        _c(
          "div",
          { staticClass: "right" },
          [
            _c("div", { staticClass: "title" }, [_vm._v("未加入公司")]),
            _c("BaseTable", {
              attrs: { height: 500, tableData: _vm.tableData, isPager: false },
              on: { handleSelectionChange: _vm.rightSelectionChange },
            }),
          ],
          1
        ),
        _c("div", { staticClass: "arrow_content" }, [
          _c(
            "div",
            {
              staticClass: "arrow flex_c_c",
              attrs: { title: "向右移动并加入公司" },
              on: { click: _vm.right },
            },
            [_c("i", { staticClass: "el-icon-arrow-right" })]
          ),
          _c(
            "div",
            {
              staticClass: "arrow flex_c_c",
              attrs: { title: "向左移动并移除公司" },
              on: { click: _vm.left },
            },
            [_c("i", { staticClass: "el-icon-arrow-left" })]
          ),
        ]),
        _c(
          "div",
          { staticClass: "left" },
          [
            _c("div", { staticClass: "title" }, [_vm._v("已加入公司")]),
            _c("BaseTable", {
              attrs: { height: 500, tableData: _vm.tableData1, isPager: false },
              on: { handleSelectionChange: _vm.leftSelectionChange },
            }),
          ],
          1
        ),
      ]),
      _c(
        "span",
        { staticClass: "footers", attrs: { slot: "footer" }, slot: "footer" },
        [
          _c("div", { staticClass: "cancel", on: { click: _vm.cancel } }, [
            _vm._v("取 消"),
          ]),
          _c(
            "div",
            {
              staticClass: "ok",
              on: {
                click: function ($event) {
                  return _vm.ok("form")
                },
              },
            },
            [_vm._v("确 定")]
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }